import { render, staticRenderFns } from "./CarCreate.vue?vue&type=template&id=7315295a"
import script from "./CarCreate.vue?vue&type=script&lang=ts"
export * from "./CarCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports